import React, { FC, useState } from 'react'
import { FetchMore } from '@pandiafi/design-system'

import { FeedbackAndQuestionNoticeListItem } from '../../../common/validations/feedbackAndQuestionNotice'
import { ContactInfoNoticeCard } from '../ContactInfoNoticeCard'

const NBR_OF_NOTICES_TO_SHOW = 5

export const ContactInfoNoticesList: FC<{
  notices: FeedbackAndQuestionNoticeListItem[]
}> = ({ notices }) => {
  const [showAll, setShowAll] = useState(false)
  const isShowMoreVisible = !showAll && notices.length > NBR_OF_NOTICES_TO_SHOW
  const noticesToShow = showAll
    ? notices
    : notices.slice(0, NBR_OF_NOTICES_TO_SHOW)

  return (
    <div className="mt-4 mb-8 desktop:my-8 tablet:grid tablet:grid-cols-2 tablet:gap-x-8">
      {noticesToShow.map((notice) => (
        <div className="mt-4" key={`feedbackQuestionNotice-${notice.id}`}>
          <ContactInfoNoticeCard notice={notice} />
        </div>
      ))}
      {isShowMoreVisible && (
        <div className="text-center pt-3">
          <FetchMore
            fetchMoreItemsCount={notices.length - NBR_OF_NOTICES_TO_SHOW}
            onFetchMoreItemsClick={() => setShowAll(true)}
          />
        </div>
      )}
    </div>
  )
}
